export default __webpack_public_path__ + "static/media/logo.06a83cbe.png";